<div class="table-container group-table-container" [class.table-container--loading]="isLoading">
  <mat-table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="expand">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-expand"
                [ngClass]="{'align-top': expandedGroupId === groupKey(element), 'expand-margin': expandedGroupId === groupKey(element)}">
        <button mat-icon-button (click)="toggleMembers(groupKey(element)); $event.stopPropagation()">
          <mat-icon>{{ expandedGroupId === groupKey(element) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'group.name' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedGroupId === groupKey(element)}">
        <div class="cell-content">
          <div>{{ element.name }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'group.email' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedGroupId === groupKey(element)}">
        <div class="cell-content">
          <div>{{ element.email }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="directMembersCount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'group.count' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div *ngIf="expandedGroupId !== groupKey(element)" class="cell-content">{{ element.directMembersCount }}</div>
        <div *ngIf="expandedGroupId === groupKey(element)">
          <mat-list>
            <mat-list-item *ngFor="let member of element.members" class="group-members">
              {{ member }}
            </mat-list-item>
          </mat-list>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="defaultForEmployees">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'group.defaultForEmployees' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [matTooltip]="'group.defaultForEmployeesHint' | translate"
          (click)="$event.stopPropagation()" (change)="toggleDefaultInstallation($event, element)"
                          [checked]="isDefaultGroupInstallationSelected(groupKey(element))"/>
        <a class="group-signature-link"
           target="_blank"
           *ngIf="element.templateName && element.templateId !== currentSignatureId"
           [routerLink]="['/signatures', 'custom', element.templateId]">{{ element.templateName }}</a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="assign">
      <mat-header-cell *matHeaderCellDef>{{ 'footers.set' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedGroupId === groupKey(element)}">
        <div class="table-actions group-actions">
          <button type="button" class="action-btn" (click)="assign(element.email); $event.stopPropagation()" [disabled]="updating">
            <mat-icon>check</mat-icon>
            {{ (updating ? 'footers.setting' : 'footers.set') | translate }}
          </button>
          <button *ngIf="showAliasOptions" type="button" class="action-btn" (click)="assignToAll(element.email, element.email); $event.stopPropagation()"
                  [disabled]="updating">
            <mat-icon>done_all</mat-icon>
            {{ (updating ? 'footers.setting' : 'footers.installAllWithAlias') | translate }}
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="toggleMembers(groupKey(row))"></mat-row>
  </mat-table>

  <div class="loading-wrapper" *ngIf="isLoading">
    <app-loading [hideText]="true"></app-loading>
  </div>
</div>
